export default __webpack_public_path__ + "static/media/page1.a0ff0c7e.png";